import { render, staticRenderFns } from "./ValidationsSelect.vue?vue&type=template&id=54c2718c"
import script from "./ValidationsSelect.vue?vue&type=script&lang=js"
export * from "./ValidationsSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports